/**
 * 删除指定任务中的图形 API
 */
export interface DeleteFigureRequest {
    /**
     * 任务 ID
     */
    taskId: string;

    /**
     * 图形 ID
     */
    figureId: string;
}

/**
 * 删除图形响应
 */
export interface DeleteFigureResponse {
    /**
     * 删除的图形 ID
     */
    removed_figure_id: boolean;
    /**
     * 剩余的图形数量
     */
    remaining_figure_count: number;
}

/**
 * 删除图形 API 接口
 */
export interface DeleteFigureApi {
    /**
     * 删除指定任务中的图形
     * @param request 删除图形请求参数
     * @returns 删除结果
     */
    deleteFigure(request: DeleteFigureRequest): Promise<DeleteFigureResponse>;
}

export const DeleteFigureApi = Symbol.for('DeleteFigureApi');
